import { Col, Row, Space } from "antd";
import React, { useEffect, useState } from "react";


const years = () => {
  const currentYear = new Date().getFullYear();
  const nextYear = new Date(new Date().setFullYear(currentYear + 1)).getFullYear();
  return [currentYear, nextYear]
};
const months = Array.from({length: 12}, (item, i) => {
  return {
    shortMonth: new Date(0, i).toLocaleString('en-US', {month: 'short'}), 
    name: new Date(0, i).toLocaleString('en-US', {month: 'long'})
  }
});


function FilterPills(
  props: {
    items:any[];
    title?:string;
    initialValue:{keyword?:string, year?:any, month?: string, location_id?:any, type?: any}
    bindLabel:string;
    bindValue:string;
    allOption:boolean;
    selectFilter;
  }){
  
  const { items, title, bindLabel, bindValue, initialValue, allOption } = props;

  const [selected, setSelected] = useState(initialValue);

  const allHasValues = () => {
    const {keyword, ...noKeyword} = selected;
    return Object.entries(noKeyword).every(o => o[1] != "" && o[1] != null);
  }
  const [collapseFilters, setcollapseFilters] = useState(allHasValues);
  
  const selectFilter = (label, value) => {
    selected[label] = value;
    setSelected(selected);
  
    setcollapseFilters(allHasValues);

    props.selectFilter(selected);
  }

  return (
    <>
      {
        collapseFilters==false && (

          <Space size={12} direction="vertical">
            {
              items && (
                <>
                  { title && <div className="filter-title"> {title} </div> }
                  <Space size={10} wrap>
                      {
                        allOption && <div onClick={()=>selectFilter(bindValue, null)} className={`filter-pill ${(selected[bindValue] == null || selected[bindValue] == '') && 'selected'}`}> <span> All </span></div>
                      }
                      {
                        items.map((item, index) => {
                          //special case for location id
                          const id:any = bindValue == "location_id" ? "id" : bindValue;
                          const value = bindValue ? item[id] : item;
                          const selectedItem = selected && bindValue ? selected[bindValue]: item ;
                          return <div key={index} onClick={()=>selectFilter(bindValue, value)} className={`filter-pill ${selectedItem == value && 'selected'}`}> <span>{ item[bindLabel] } </span></div>
                        })
                      }
                  </Space>
                </>
              )
            }
      
            <div className="filter-title"> Year </div>
            <Space size={10} wrap>
              {
                allOption && <div onClick={()=>selectFilter("year", "")} className={`filter-pill ${selected.year == '' && 'selected'}`}> <span> All </span></div>
              }
              {
                years().map((year, index) => (
                  <div key={index} onClick={()=>selectFilter("year", year)} className={`filter-pill default-filter ${selected.year == year && 'selected'}`}> <span>{year} </span></div>
                ))
              }
            </Space>
      
            <div className="filter-title"> Month </div>
            <Row gutter={[10, 10]} justify="space-between">
              {
                allOption && <div onClick={()=>selectFilter("month", "")} className={`filter-pill ${selected.month == '' && 'selected'}`}> <span> All </span></div>
              }
              {
                months.map((month, index) => (
                  <Col key={index} xs={8} md={6} lg={4}> <div onClick={()=>selectFilter("month", month.shortMonth)} className={`filter-pill default-filter ${selected.month == month.shortMonth && 'selected'}`}> <span>{month.name} </span></div> </Col>
                ))
              }
            </Row>
          </Space>
        )
        
      }
    </>
  )
  
}

FilterPills.defaultProps = {
  allOption: false,
  bindLabel: "label",
  bindValue: "id"
}

export default FilterPills;